// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2U7zA","content":"styles_content__2gz3o","checkbox":"styles_checkbox__3B66S","checkboxLabel":"styles_checkboxLabel__2rqhU"};